module.exports = __webpack_public_path__ + "img/aave.b3a29748.svg";